import { Euler, Vector3 } from 'three';

export interface SensorPose {
  position: [number, number, number];
  rotation: [number, number, number];
}

const EULER_ORDER = 'ZYX' as const;

/** Filter points by world/global Z after applying the sensor pose. */
export function filterPointsByHeight(
  points: Float32Array,
  minZ: number | null,
  maxZ: number | null,
  sensorPose?: SensorPose | null,
): Float32Array {
  if (minZ === null && maxZ === null) {
    return points;
  }

  if (!sensorPose) {
    return points;
  }

  const rotation = new Euler(
    sensorPose.rotation[0],
    sensorPose.rotation[1],
    sensorPose.rotation[2],
    EULER_ORDER,
  );
  const position = new Vector3(
    sensorPose.position[0],
    sensorPose.position[1],
    sensorPose.position[2],
  );
  const local = new Vector3();
  const world = new Vector3();
  const filtered: number[] = [];

  for (let i = 0; i < points.length; i += 3) {
    local.set(points[i], points[i + 1], points[i + 2]);
    world.copy(local).applyEuler(rotation).add(position);
    if (minZ !== null && world.z < minZ) {
      continue;
    }
    if (maxZ !== null && world.z > maxZ) {
      continue;
    }
    filtered.push(points[i], points[i + 1], points[i + 2]);
  }

  return new Float32Array(filtered);
}

export const parseHeightCutoffInput = (value: string): number | null => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return null;
  }
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatHeightCutoff = (value: number | null): string =>
  value === null ? '' : String(value);
